import { lazy } from "react";
import LearnRovrModal from "../common/components/tour/LearnRovrModal";
import TourModeScreen from "../common/components/tour/TourModescreen";
function retry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}
const Scorecard = lazy(() => retry(() => import("../modules/scorecard/ScorecardContainer")));
const FeedBackContainer = lazy(() => retry(() =>
  import("../modules/feed-back/FeedBackContainer")
));
const FaqsContainer = lazy(() => retry(() => import("../modules/faqs/FaqsContainer")));
const TimelineContainer = lazy(() => retry(() =>
  import("../modules/shift/TimelineContainer"))
);
const TaskContainer = lazy(() => retry(() => import("../modules/task/TaskContainer")));
const ShiftContainer = lazy(() => retry(() => import("../modules/shift/ShiftContainer")));
const AuthenticationContainer = lazy(() => retry(() =>
  import("../modules/authentication/AuthenticationContainer")
));
const ScorecardDashboard = lazy(() => retry(() =>
  import("../modules/scorecardDashboard/SCDashboardComponent")
));
const NotifyContainer = lazy(() => retry(() =>
  import("../modules/notification/NotificationContainer")
));
const FeedBackThanks = lazy(() => retry(() =>
  import("../modules/feed-back/FeedBackThanks")
));
const ChangeMyStationComponent = lazy(() => retry(() =>
  import("../modules/change-my-station/ChangeMyStationComponent")
));
const DownloadMobileComponent = lazy(() => retry(() =>
  import("../modules/downloadMobile/DownloadMobile")
));
const SearchPreferenceContainer = lazy(() => retry(() =>
  import("../modules/search/SearchPreference")
));
const TaskHistoryContainer = lazy(() => retry(() =>
  import("../modules/taskHistoryModule/TaskHistoryContainer")
));
const MyFlightsContainer = lazy(() => retry(() =>
  import("../modules/myFlights/MyFlightsContainer")
));
const BetaStationContainer = lazy(() => retry(() =>
  import("../modules/beta/BetaStationContainer")
));
const routes = [
  {
    path: "/",
    exact: true,
    component: AuthenticationContainer,
    id: 1,
  },
  {
    path: "/task",
    exact: true,
    component: TaskContainer,
    id: 2,
  },
  {
    path: "/shift",
    exact: true,
    component: ShiftContainer,
    id: 3,
  },
  {
    path: "/timeline",
    exact: true,
    component: TimelineContainer,
    id: 4,
  },
  {
    path: "/notification",
    exact: true,
    component: NotifyContainer,
    id: 5,
  },
  {
    path: "/feedback",
    exact: true,
    component: FeedBackContainer,
    id: 6,
  },
  {
    path: "/faqs",
    exact: true,
    component: FaqsContainer,
    id: 7,
  },
  {
    path: "/feedbacksuccess",
    exact: true,
    component: FeedBackThanks,
    id: 8,
  },
  {
    path: "/tasksearch",
    exact: true,
    component: TaskContainer,
    id: 9,
  },
  {
    path: "/changemystation",
    exact: true,
    component: ChangeMyStationComponent,
    id: 10,
  },
  {
    path: "/downloadMobile",
    exact: true,
    component: DownloadMobileComponent,
    id: 11,
  },
  {
    path: "/search-defaults",
    exact: true,
    component: SearchPreferenceContainer,
    id: 12,
  },
  {
    path: "/taskHistory",
    exact: true,
    component: TaskHistoryContainer,
    id: 13,
  },
  {
    path: "/tourMode",
    exact: true,
    component: TourModeScreen,
    id: 14,
  },
  {
    path: "/scorecard",
    exact: true,
    component: Scorecard,
    id: 15,
  },
  {
    path: "/scorecardDashboard",
    exact: true,
    component: ScorecardDashboard,
    id: 16,
  },
  {
    path: "/myFlights",
    exact: true,
    component: MyFlightsContainer,
    id: 17,
  },
  {
    path: "/beta",
    exact: true,
    component: BetaStationContainer,
    id: 18,
  },

];

export default routes;
